import { useTranslation } from 'react-i18next';
import { resources } from '../../../resources/resources';
import ImportCardsFileForm from './Components/ImportCardsFileForm';

export default function ImportCardsPage() {
  const { t: translate } = useTranslation();
  return (
    <div className="panel padding-xl uploads-panel">
      <h1>{translate(resources.admin.importCards.title)}</h1>
      <ImportCardsFileForm />
    </div>
  );
}
